export const Fillings = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_107_16306)">
      <path
        d="M2.33333 9.91667H6.41667V11.0833H2.33333V9.91667ZM6.41667 7.58333H2.33333V8.75H6.41667V7.58333ZM14 7.94792V10.2293C14 12.5802 11.8043 13.6465 11.1318 13.9172L10.7648 14.0647L10.4125 13.8862C9.75042 13.5561 7.58333 12.3118 7.58333 10.2287V7.94733C7.58333 7.4445 7.90475 6.99942 8.3825 6.84133L10.7917 6.04275L13.2008 6.84133C13.6786 6.99942 14 7.4445 14 7.94733V7.94792ZM12.8333 7.94792L10.7917 7.27242L8.74942 7.94908V10.2293C8.74942 11.5599 10.2853 12.4979 10.8185 12.7838C11.4199 12.5183 12.8333 11.7349 12.8333 10.2293V7.94792ZM8.44608 14H0V1.75C0 0.785167 0.785167 0 1.75 0H7.2415L11.6667 4.42517V5.25H6.41667V1.16667H1.75C1.428 1.16667 1.16667 1.428 1.16667 1.75V12.8333H7.31208C7.65392 13.2959 8.05525 13.6844 8.44608 14ZM7.58333 4.08333H9.67517L7.58333 1.9915V4.08333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_107_16306">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
